import { render, staticRenderFns } from "./detailMore.vue?vue&type=template&id=8df9f8ac&scoped=true&"
import script from "./detailMore.vue?vue&type=script&lang=js&"
export * from "./detailMore.vue?vue&type=script&lang=js&"
import style0 from "./detailMore.vue?vue&type=style&index=0&id=8df9f8ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df9f8ac",
  null
  
)

export default component.exports